var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-steps',{staticClass:"steps",attrs:{"active":_vm.active,"finish-status":"success","simple":""}},[_c('el-step',{attrs:{"title":"总体信息"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"环境信息"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"道路信息"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"参与方信息"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6449134","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/data/newCase_steps.vue
// module id = null
// module chunks = 